import React from 'react';
import styled from 'styled-components';
import {mmWave as mmWv} from '../map/index'
import {homeIcon,antennaIcon} from './map-icons.js';
import { getHereKey } from '../../../src/constants/api-urls';

const MapContainer = styled.div`
  border: 0.0625rem solid #959595;
  position: relative;
  min-height: 320px;
  overflow: hidden;
  width:100%;
  min-width:300px;
  @media (max-width: 768px) {
    min-height: 350px;
}
.mapboxgl-popup-close-button,.mapboxgl-popup-close-button:hover{
  color:black;
  padding:1px 6px;
}
.mapboxgl-ctrl-traffic{
  display:none;
}
`;
const MapView = styled.div`
  height: 350px;
`;
const RefreshDiv = styled.div`
position: absolute;
top: 35%;
right: 0;
display:inline-block;
z-index: 100;  
cursor:pointer;
margin:10px;
`;
const RefreshIcon = styled.div`
height:35px;
width:35px;
background-image: url(//www.verizonwireless.com/content/dam/vzwcom/5g/images/refreshbk.png);
margin:auto !important;;
`;
const RefreshText = styled.div`
  color:rgb(0,0,0);
  background-color:blue:
  font-size:12px  
.`;

class HereMap extends React.PureComponent {
    constructor(props) {
        super(props);
        this.map = null;
        this.addPolylineToMap = this.addPolylineToMap.bind(this);
        this.addIcons =this.addIcons.bind(this);
        this.showLoader;
        this.hideLoader;
        this.state = {
            map: null,
        }
    }
    componentDidMount() {
        const { H } = window; // for cdn -- need to comment for npm
        this.setUpLoader();
        if (H && H.service && H.service.Platform && H.mapevents && H.mapevents.Behavior && !this.state.map) {
          this.loadMap();
        }else{
            setTimeout(() => {
                this.loadMap();
            }, 2000);          
        }
    }
    centerMap = () => {
      const lqMapContainer = document.getElementById("myMap");
      if(lqMapContainer && lqMapContainer.firstChild ){
      lqMapContainer.firstChild.remove();
      }
      this.loadMap();
    };
    componentWillUnmount() {
        // Cleanup after the map to avoid memory leaks when this component exits the page
        this.state.map && this.state.map.dispose && this.state.map.dispose();
    }
    setUpLoader = () => {
        const { loader } = this.props;
        if (loader && typeof loader.show === 'function' && (typeof loader.hide === 'function')) {
          this.showLoader = loader.show;
          this.hideLoader = loader.hide;
        } else {
          this.showLoader = () => {};
          this.hideLoader = () => {};
        }
      };
    loadMap() {
        try {
          console.log('Begin initialization hereMap');
          this.showLoader();
          const { H } = window; // for cdn -- need to comment for npm
          if (H) {
            const platform = new H.service.Platform({
              apikey: getHereKey(),
            });
            const engineType = H.Map.EngineType.HARP;
            const defaultLayers = platform.createDefaultLayers({ engineType });
            const { zoomIndex } = this.props;
            const map = new H.Map(document.getElementById('myMap'), defaultLayers.raster.normal.map, {
              engineType,
              pixelRatio: window.devicePixelRatio,
              zoom: zoomIndex,
              center: {
                lng: this.props.eagleSignalLines ? this.props.compassApp.coords[0][0] : this.props.compassApp.lgt,
                lat: this.props.eagleSignalLines ? this.props.compassApp.coords[0][1] : this.props.compassApp.lat,
              },
            });
            const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
            const ui = new H.ui.UI.createDefault(map, defaultLayers);
            ui.removeControl("mapsettings");
            var ms = new H.ui.MapSettingsControl({
              baseLayers: [{
                label: "Normal", layer: defaultLayers.raster.normal.map
              }, {
                label: "Satellite", layer: defaultLayers.raster.satellite.map
              }
              ]
            });
            ui.addControl("customized", ms);
            this.setState({ map });            
            this.render();
            this.hideLoader();
            this.addPolylineToMap(map);
            this.addIcons(map)
            console.log('End initialization');
          }
        } catch (ex) {
          this.hideLoader();
          console.log(ex);
        }
      }
      addIcons =(map)=>{
        let coordspresent =this.props.compassApp && this.props.compassApp.coords && this.props.compassApp.coords.length ? true : false;
        if(this.props.compassApp && this.props.compassApp.lat && !coordspresent){
        let LocationOfMarker = { lat: this.props.compassApp.lat, lng: this.props.compassApp.lgt };
        let Icon = new H.map.Icon(homeIcon);
        let marker = new H.map.Marker(LocationOfMarker, { icon: Icon });
        map.addObject(marker);
        }
        this.props.compassApp && this.props.compassApp.nodes && this.props.compassApp.nodes.forEach(val => {
          let LocationOfMarker = { lat: val.latitude, lng: val.longitude };
          let Icon = new H.map.Icon(antennaIcon);
          let marker = new H.map.Marker(LocationOfMarker, { icon: Icon });
          map.addObject(marker);
        })
      }
      addPolylineToMap =(map)=>{
        if(this.props.compassApp && this.props.compassApp.coords && this.props.compassApp.coords.length ){
        var lineString = new H.geo.LineString();
        let numberOfPoint = this.props.compassApp.coords.length;
        for (var i = 0; i <= numberOfPoint - 1; i++) {
          lineString.pushPoint({lat:this.props.compassApp.coords[i][1], lng:this.props.compassApp.coords[i][0]}); 
        }
        map.addObject(new H.map.Polyline(
          lineString, { style: { lineWidth: 3, strokeColor : "green" }}
        ));
        }
      };
    render() {
        return (<>
            <MapContainer>
            <RefreshDiv id="refreshId" onClick={() => this.centerMap()}>
            <RefreshIcon className="mapRefreshIcon" title="Click to recenter the map"></RefreshIcon>
            <RefreshText className="mapRefreshText">Refresh</RefreshText>
           </RefreshDiv>
              <MapView id={this.props.id} />
            </MapContainer>
          </>
        )
    }
}
export default HereMap;